import React from 'react';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  SimpleGrid,
  Stack,
  Textarea,
} from '@chakra-ui/react';
import { Company } from '../../../utils/types';
import { CompanySectionCard } from './companyUi';

export type CompanyDraft = {
  id: string;
  name: string;
  website: string;
  email: string;
  phone: string;
  address: string;
};

export const emptyCompanyDraft: CompanyDraft = {
  id: '',
  name: '',
  website: '',
  email: '',
  phone: '',
  address: '',
};

export const toCompanyDraft = (company?: Company | null): CompanyDraft => ({
  id: company?.id || '',
  name: company?.name || '',
  website: company?.website || '',
  email: company?.email || '',
  phone: company?.phone || '',
  address: company?.address || '',
});

export const CompanyFormSections = ({
  draft,
  onChange,
}: {
  draft: CompanyDraft;
  onChange: (field: keyof CompanyDraft, value: string) => void;
}) => (
  <Stack spacing={6}>
    <CompanySectionCard
      title="Company basics"
      description="Add the main identity details used across the CRM."
    >
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5}>
        <FormControl isRequired>
          <FormLabel>Company name</FormLabel>
          <Input
            value={draft.name}
            onChange={(event) => onChange('name', event.target.value)}
            borderRadius="16px"
            bg="gray.50"
            placeholder="Acme Corporation"
          />
        </FormControl>
        <FormControl>
          <FormLabel>Website</FormLabel>
          <Input
            value={draft.website}
            onChange={(event) => onChange('website', event.target.value)}
            borderRadius="16px"
            bg="gray.50"
            placeholder="https://acme.com"
          />
          <FormHelperText>Add the main website or domain.</FormHelperText>
        </FormControl>
      </SimpleGrid>
    </CompanySectionCard>

    <CompanySectionCard
      title="Contact details"
      description="These fields help the team reach the company quickly."
    >
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5}>
        <FormControl>
          <FormLabel>Company email</FormLabel>
          <Input
            type="email"
            value={draft.email}
            onChange={(event) => onChange('email', event.target.value)}
            borderRadius="16px"
            bg="gray.50"
            placeholder="hello@acme.com"
          />
        </FormControl>
        <FormControl>
          <FormLabel>Phone number</FormLabel>
          <Input
            value={draft.phone}
            onChange={(event) => onChange('phone', event.target.value)}
            borderRadius="16px"
            bg="gray.50"
            placeholder="+263..."
          />
        </FormControl>
      </SimpleGrid>
    </CompanySectionCard>

    <CompanySectionCard
      title="Address"
      description="Store the main office or mailing address when available."
    >
      <FormControl>
        <FormLabel>Address</FormLabel>
        <Textarea
          value={draft.address}
          onChange={(event) => onChange('address', event.target.value)}
          borderRadius="16px"
          bg="gray.50"
          minH="120px"
          placeholder="Office address"
        />
      </FormControl>
    </CompanySectionCard>
  </Stack>
);
